import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box, Image } from '@bonanza-social/moonlight';
import IntroHeader from '../IntroHeader/IntroHeader';
import IntroMainContent from '../IntroMainContent/IntroMainContent';
import { IntroMainContentVariants } from '../IntroMainContent/IntroMainContent.types';
import { selectIsExistingUser } from '../../state';

function Intro() {
  const isExistingUser = useSelector(selectIsExistingUser);
  const variant = isExistingUser
    ? IntroMainContentVariants.existingPlayer
    : IntroMainContentVariants.default;

  return (
    <Box flex={1}>
      <Image
        position="absolute"
        top="space-0"
        left="space-0"
        width="100%"
        height="80%"
        contentFit="cover"
        name="auth.IntroBackgroundDefault"
      />
      <Box
        flex={1}
        flexDirection="column"
        justifyContent="space-between"
        paddingHorizontal="space-600"
        paddingTop="safe-area-inset-top"
        paddingBottom="safe-area-inset-bottom"
      >
        <Box
          paddingVertical="space-100"
          alignItems="center"
          backgroundColor="accentBackground"
        >
          <IntroHeader />
        </Box>
        <IntroMainContent variant={variant} />
      </Box>
    </Box>
  );
}

export default memo(Intro);
